// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.rigaProgresso[data-v-b7332368]:hover {\n    background-color: transparent !important;\n}\n.rigaProgresso td[data-v-b7332368] { \n    background-color: #FFFDE7;\n    font-weight: bold;\n    text-align: center;\n    padding: 0 !important;\n    color: black;\n}\n.rigaProgresso  td[data-v-b7332368]:last-child { \n    background-color: transparent;\n}\n", ""]);
// Exports
module.exports = exports;
